<template>
  <div class="page_container">
    <header>
      <div class="btn"><a class="pointer" @click="goToReLocation">리:로케이션 바로가기</a></div>
    </header>
    <main>
      <h1>리:로케이션 서비스 의뢰서</h1>
      <p>본 의뢰서 작성은 리:로케이션 서비스를 이용함에 있어, 현황 및 희망 서비스를 파악하는데 목적이 있습니다.<br class="br" />현재 기준으로 확정된 정보만 편하게 기재 부탁드립니다.</p>
    </main>

    <div class="content_box">
      <h2>기본 정보 작성</h2>
      <section class="section_box00 section_box01">
        <div class="sub_title">
          <img src="../assets/img/relocation/sup_p_icon_dot.png" alt="점" />
          <h3>기본 정보</h3>
        </div>
        <div class="info_box">
          <div class="l_box">
            <!-- 이름 -->
            <label for="name">이름<span class="essential">*</span></label>
            <input type="text" name="name" v-model="inquiryData.name" placeholder="담당자명을 입력해 주세요." />
            <!-- 이메일 -->
            <label class="sub_title_label" for="email">이메일 주소<span class="essential">*</span></label>
            <input type="email" name="email" v-model="inquiryData.email" placeholder="이메일을 입력해 주세요." />
            <!-- 거주지 -->
            <label class="sub_title_label" for="adress">거주지<span class="essential">*</span></label>
            <label class="adress_box" for="adress_box">
              <input
                id="get_adress_box"
                type="text"
                name="adress"
                v-model="inquiryData.address1"
                placeholder="거주지역 구 까지 입력. ex) 서울특별시 영등포구
"
              />
              <!-- @click="showApi" -->
              <!-- <button ref="btn" @click="showApi">검색</button> -->
            </label>
            <!-- <input type="text" name="adress2" v-model="inquiryData.address2" placeholder="상세주소지를 입력해 주세요." /> -->
          </div>
          <div class="r_box">
            <!-- 연락처 -->
            <label class="sub_title_label_02" for="callnumber">연락처<span class="essential">*</span></label>
            <input type="text" name="callnumber" v-model="inquiryData.mobile" placeholder="연락처를 입력해 주세요." />
            <!-- 회사명 -->
            <label class="sub_title_label" for="company">회사명<span class="essential">*</span></label>
            <input type="text" name="company" v-model="inquiryData.companyname" placeholder="회사명을 입력해 주세요." />
            <!-- 비용처리 -->
            <label class="sub_title_label" for="cost">비용 처리<span class="essential">*</span></label>
            <label class="check_label" for="personalBurden"> <input value="개인 부담" type="radio" id="personalBurden" v-model="inquiryData.pay" name="cost" /> 개인 부담 </label>
            <label class="check_label" for="company"> <input value="company" type="radio" id="회사 부담" v-model="inquiryData.pay" name="cost" /> 회사 부담 </label>
            <label class="check_label" for="undefinedCost"> <input value="미정" type="radio" id="undefinedCost" v-model="inquiryData.pay" name="cost" /> 미정 </label>
          </div>
        </div>
      </section>

      <section class="section_box00 section_box02">
        <div class="sub_title">
          <img src="../assets/img/relocation/sup_p_icon_dot.png" alt="점" />
          <h3>파견 정보</h3>
        </div>
        <div class="info_box">
          <div class="l_box">
            <!-- 파견 국 -->
            <label for="country">파견 국<span class="essential">*</span></label>
            <!-- v-model="inquiryData.countryList" -->
            <select class="country_box" v-model="inquiryData.dispatch_country" for="country_box">
              <option value="" disabled>선택</option>
              <option :value="item.code_eng3" v-for="(item, index) in countryList" :key="index">{{ item.code_kname }} ({{ item.code_ename }})</option>
            </select>
            <!-- 가족 파견 유무 -->
            <label class="sub_title_label" for="family">가족 파견 유무<span class="essential">*</span></label>
            <label class="check_label" for="personalDispatch">
              <input value="개인 파견" type="radio" id="personalDispatch" v-model="inquiryData.dispatch_family" name="familyDispatch" @click="handleChildrenEtc2" /> 본인만
            </label>
            <label class="check_label" for="spouse">
              <input value="배우자 파견" type="radio" id="spouse" v-model="inquiryData.dispatch_family" name="familyDispatch" @click="handleChildrenEtc3" /> 배우자 포함
            </label>
            <label class="check_label" for="children">
              <input value="배우자 및 자녀 파견" type="radio" id="children" v-model="inquiryData.dispatch_family" name="familyDispatch" @click="handleChildrenEtc" /> 자녀 포함
            </label>
            <label class="check_label" for="undefinedDispatch">
              <input value="미정" type="radio" id="undefinedDispatch" v-model="inquiryData.dispatch_family" name="familyDispatch" @click="handleChildrenEtc4" /> 미정
            </label>
            <!-- 파견 사유 -->
            <label class="sub_title_label" for="dispatch">파견 사유<span class="essential">*</span></label>
            <label class="check_label" for="business">
              <input @click="handleEtcInput1" value="단순 출장" type="radio" id="business" v-model="inquiryData.dispatch_reason" name="dispatchReason" /> 단순 출장
            </label>
            <label class="check_label" for="expatriates">
              <input @click="handleEtcInput2" value="주재원 발령" type="radio" id="expatriates" v-model="inquiryData.dispatch_reason" name="dispatchReason" /> 주재원 발령
            </label>
            <label class="check_label" for="president">
              <input @click="handleEtcInput3" value="법인장 발령" type="radio" id="president" v-model="inquiryData.dispatch_reason" name="dispatchReason" /> 법인장 발령
            </label>
            <label class="check_label" for="etc"> <input @click="handleEtcInput0" value="기타" type="radio" id="etc" v-model="inquiryData.dispatch_reason" name="dispatchReason" /> 기타 ( ) </label>
            <!-- 기타 클릭 시 생성 -->
            <input v-if="isShowEtcInput" type="text" name="etc_2" v-model="inquiryData.dispatch_reason_txt" placeholder="기타 사유를 적어주세요" />
          </div>
          <div class="r_box">
            <!-- 파견 도시 -->
            <label class="sub_title_label_02" for="city">파견 도시<span class="essential">*</span></label>
            <input type="text" name="name" v-model="inquiryData.dispatch_city" placeholder="파견 도시를 입력해 주세요." />
            <!-- 자녀 포함(자녀 수, 연령) -->
            <div v-if="isShowChildrenEtc">
              <!-- 자녀 연령 -->
              <label class="sub_title_label" for="age">자녀 연령 (초중고 학년과 자녀 생년월일)<span class="essential">*</span></label>
              <!-- 자녀 연령(직접 작성) -->
              <input v-if="isShowChildrenWriteEtc" type="text" name="childAge" v-model="inquiryData.dispatch_children_age_txt" placeholder="초중고 학년과 자녀 생년월일을 입력해주세요." />
              <!-- 자녀 수 -->
              <label class="sub_title_label" for="howMany">자녀 수</label>
              <!-- <input type="text" name="home" v-model="inquiryData.dispatch_children_howmany" placeholder="1명, 2명, 3명, 4명이상" /> -->
              <label class="check_label" for="onePerson"> <input value="1명" type="radio" id="onePerson" v-model="inquiryData.dispatch_children_howmany" name="childrenHowMany" /> 1명 </label>
              <label class="check_label" for="twoPerson"> <input value="2명" type="radio" id="twoPerson" v-model="inquiryData.dispatch_children_howmany" name="childrenHowMany" /> 2명 </label>
              <label class="check_label" for="threePerson"> <input value="3명" type="radio" id="threePerson" v-model="inquiryData.dispatch_children_howmany" name="childrenHowMany" /> 3명 </label>
              <label class="check_label" for="fourOrMore">
                <input value="4명 이상" type="radio" id="fourOrMore" v-model="inquiryData.dispatch_children_howmany" name="childrenHowMany" /> 4명 이상
              </label>
            </div>
            <!-- 파견 기간 -->
            <label class="sub_title_label" for="period">파견 기간<span class="essential">*</span></label>
            <label class="check_label" for="six"> <input value="6개월 미만" type="radio" id="six" v-model="inquiryData.dispatch_period" name="dispatchPeriod" /> 6개월 미만 </label>
            <label class="check_label" for="one"> <input value="1~2년" type="radio" id="one" v-model="inquiryData.dispatch_period" name="dispatchPeriod" /> 1~2년 </label>
            <label class="check_label" for="three"> <input value="3~4년" type="radio" id="three" v-model="inquiryData.dispatch_period" name="dispatchPeriod" /> 3~4년 </label>
            <label class="check_label" for="five"> <input value="5년 이상" type="radio" id="five" v-model="inquiryData.dispatch_period" name="dispatchPeriod" /> 5년 이상 </label>
            <label class="check_label" for="undefinedPeriod"> <input value="미정" type="radio" id="undefinedPeriod" v-model="inquiryData.dispatch_period" name="dispatchPeriod" /> 미정 </label>
            <!-- 파견 도시 -->
            <label class="sub_title_label" for="city">파견 예정일<span class="essential">*</span></label>
            <input type="text" name="name" v-model="inquiryData.dispatch_due_date" placeholder="파견 예정일을 입력해 주세요." />
          </div>
        </div>
      </section>
      <div v-click-outside="onClickOutside" class="footer">
        <div class="info_check_box">
          <label class="check_label" for="decide">
            <input v-model="inquiryData.agree" type="checkbox" id="decide" name="decide" />
            <span class="pop_up">개인정보 수집 및 이용</span>에 동의합니다.
          </label>
          <div v-if="isShowPrivacyModal" class="termsWrap">
            <div class="terms_title">
              <!-- <img src="../assets/img/relocation/icon_close.png" @click="handleOnOffModal" alt="닫기" /> -->
              <div class="terms_summary">
                <p>
                  ㈜캐럿글로벌은 다음과 같이 개인정보를 수집 및 이용하고 있습니다.<br />

                  수집 및 이용 목적: 회원 가입, 서비스 제공, 이용자 식별, 부정이용 방지, 공지사항 전달<br />
                  항목: 이름, 연락처, 이메일주소, 파견에 대한 정보 등<br />

                  보유 및 이용기간: 문의일로 부터 1년,<br />
                  동의를 거부할 권리가 있으나, 동의를 거부할 경우 회원가입이 불가능 합니다.<br /><br />

                  ※ 그 외의 사항 및 자동 수집 정보와 관련된 사항은 개인정보처리방침을 따릅니다.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_next">
          <a class="pointer" @click="handleNext">다음</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
export default {
  components: { vClickOutside },
  name: "re-location-contact",
  data() {
    return {
      isShowPrivacyModal: true,
      isShowEtcInput: false,
      isShowChildrenEtc: false,
      isShowChildrenWriteEtc: true,
      countryList: [
        {
          code_ename: "",
          code_eng3: "",
          code_kname: "",
        },
      ],
      inquiryData: {
        name: "", // 한글이름
        email: "", // 이메일
        address1: "", // 주소
        // address2: "", // 상세주소
        mobile: "", // 연락처
        companyname: "", // 회사명
        pay: "", // 비용 처리
        dispatch_country: "", // 파견국
        dispatch_family: "", // 가족 파견 유무
        dispatch_reason: "", // 파견사유 0기타, 1단순출장, 2주재원발령, 3법인장발령
        dispatch_reason_txt: "", // 파견사유 기타 내용
        dispatch_city: "", // 파견도시
        dispatch_children_age: "직접 작성", // 자녀 연령
        dispatch_children_age_txt: "", // 자녀 연령(기타)
        dispatch_children_howmany: "", // 자녀수
        dispatch_period: "", // 파견기간
        agree: false, // 동의
        idx: "",
        dispatch_due_date:"", // 파견예정일
      },
      isOnModal: false,
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mounted() {
    this.getCountryList();
  },
  methods: {
    onClickOutside(event) {
      // this.isShowPrivacyModal = false;
    },
    goToReLocation() {
      window.open("https://www.expatcare.co.kr", "_self");
    },
    handleNext() {
      let flag = false;
      for (const key in this.inquiryData) {
        if (key === "name" && !this.inquiryData[key]) {
          alert("이름을 입력해주세요");
          flag = true;
          return;
        } else if (key === "email" && !this.inquiryData[key]) {
          alert("이메일을 입력해주세요");
          flag = true;
          return;
        } else if (key === "address1" && !this.inquiryData[key]) {
          alert("주소를 입력해주세요");
          flag = true;
          return;
        }
        // else if (key === "address2" && !this.inquiryData[key]) {
        //   alert("상세주소를 입력해주세요");
        //   flag = true;
        //   return;
        // }
        else if (key === "mobile" && !this.inquiryData[key]) {
          alert("연락처를 입력해주세요");
          flag = true;
          return;
        } else if (key === "companyname" && !this.inquiryData[key]) {
          alert("회사명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "pay" && !this.inquiryData[key]) {
          alert("비용처리를 선택해주세요");
          flag = true;
          return;
        } else if (key === "dispatch_country" && !this.inquiryData[key]) {
          alert("파견국을 선택해주세요");
          flag = true;
          return;
        } else if (key === "dispatch_family" && !this.inquiryData[key]) {
          alert("가족 파견 유무를 선택해주세요");
          flag = true;
          return;
        } else if (key === "dispatch_reason" && !this.inquiryData[key]) {
          alert("파견 사유를 선택해주세요");
          flag = true;
          return;
        } else if (key === "dispatch_city" && !this.inquiryData[key]) {
          alert("파견도시를 입력해주세요");
          flag = true;
          return;
        } else if (key === "dispatch_period" && !this.inquiryData[key]) {
          alert("파견기간을 선택해주세요");
          flag = true;
          return;
        } else if (key === "dispatch_due_date" && !this.inquiryData[key]) {
          alert("파견 예정일을 입력해주세요");
          flag = true;
          return;
        } else if (this.isShowChildrenEtc==true && key === "dispatch_children_age_txt" && !this.inquiryData[key]) {
          alert("자녀 연령을 입력해주세요");
          flag = true;
          return;
        }



        else if (key === "agree" && !this.inquiryData[key]) {
          alert("개인정보 수집및 이용에 동의해주세요");
          flag = true;
          return;
        }
      }

      if (!flag) {
        var params = {
          name: this.inquiryData.name, //한글이름
          email: this.inquiryData.email, //이메일
          // address: this.inquiryData.address1 + " " + this.inquiryData.address2, //주소
          address: this.inquiryData.address1, //주소
          mobile: this.inquiryData.mobile, //연락처
          companyname: this.inquiryData.companyname, // 회사명
          pay: this.inquiryData.pay, // 비용 처리

          dispatch_country: this.inquiryData.dispatch_country, // 파견국
          dispatch_family: this.inquiryData.dispatch_family, // 가족 파견 유무
          dispatch_reason: this.inquiryData.dispatch_reason, // 파견사유 0기타, 1단순출장, 2주재원발령, 3법인장발령
          dispatch_reason_txt: this.inquiryData.dispatch_reason_txt, // 파견사유 기타내용
          dispatch_city: this.inquiryData.dispatch_city, //파견도시
          dispatch_children_age: this.inquiryData.dispatch_children_age, // 자녀 연령
          dispatch_children_age_txt: this.inquiryData.dispatch_children_age_txt, // 자녀 연령 (기타)
          dispatch_children_howmany: this.inquiryData.dispatch_children_howmany, // 자녀 수
          dispatch_period: this.inquiryData.dispatch_period, // 파견기간
          dispatch_due_date: this.inquiryData.dispatch_due_date, // 파견예정일

          idx: this.inquiryData.idx,
        };

        this.axios
          // stage
          // .post("https://stageitm.carrotenglish.net/rest/relocation/addRelocation_step1", params)
          // master
          .post("https://itm.carrotenglish.net/rest/relocation/addRelocation_step1", params)
          .then((res) => {
            console.log("location", res.data);
            if (res.data.err === 0) {
              this.$router.push({ path: `/re-location-contact-02/${res.data.idx}` });
              window.scrollTo(0, 0);
            }
          })
          .catch((err) => {
            alert("관리자에게 문의 바랍니다.");
          });
      }
    },
    handleEtcInput1() {
      this.isShowEtcInput = false;
    },
    handleEtcInput2() {
      this.isShowEtcInput = false;
    },
    handleEtcInput3() {
      this.isShowEtcInput = false;
    },
    handleEtcInput0() {
      this.isShowEtcInput = true;
    },
    handleChildrenEtc() {
      this.isShowChildrenEtc = true;
    },
    handleChildrenEtc2() {
      this.isShowChildrenEtc = false;
    },
    handleChildrenEtc3() {
      this.isShowChildrenEtc = false;
    },
    handleChildrenEtc4() {
      this.isShowChildrenEtc = false;
    },
    showApi() {
      new window.daum.Postcode({
        oncomplete: (data) => {
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

          // 도로명 주소의 노출 규칙에 따라 주소를 조합한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          let fullRoadAddr = data.roadAddress; // 도로명 주소 변수
          let extraRoadAddr = ""; // 도로명 조합형 주소 변수

          // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
            extraRoadAddr += data.bname;
          }
          // 건물명이 있고, 공동주택일 경우 추가한다.
          if (data.buildingName !== "" && data.apartment === "Y") {
            extraRoadAddr += extraRoadAddr !== "" ? ", " + data.buildingName : data.buildingName;
          }
          // 도로명, 지번 조합형 주소가 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          if (extraRoadAddr !== "") {
            extraRoadAddr = " (" + extraRoadAddr + ")";
          }
          // 도로명, 지번 주소의 유무에 따라 해당 조합형 주소를 추가한다.
          if (fullRoadAddr !== "") {
            fullRoadAddr += extraRoadAddr;
          }

          // 우편번호와 주소 정보를 해당 필드에 넣는다.
          this.zip = data.zonecode; //5자리 새우편번호 사용
          this.inquiryData.address1 = fullRoadAddr;

          document.getElementById("get_adress_box").value = data.address;
          document.querySelector("input[name=adress2]").focus();
        },
        // }).embed(this.$refs.embed);
      }).open(this.$refs.btn);
    },

    getCountryList() {
      // stage
      // this.axios.get("https://stageitm.carrotenglish.net/rest/relocation/countryList_config").then((res) => {
      // master
      this.axios.get("https://itm.carrotenglish.net/rest/relocation/countryList_config").then((res) => {
        this.countryList = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
//공통
body {
  word-break: break-word;
}
input {
  -webkit-border-radius: 0;
  font-family: "Noto Sans KR", sans-serif;
}
input:focus {
  outline: none;
}
input::placeholder {
  color: #b6b6b6;
}
label {
  font-family: "Noto Sans KR", sans-serif;
}
textarea {
  resize: none;
}
textarea:focus {
  outline: none;
}
select option[value=""][disabled] {
  display: none;
}

.select_wrap {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #c2c2c2;
  height: 38px;
  padding: 0 10px;
  background: url(~@/assets/img/relocation/sup_p_icon_arrow2.png) no-repeat 97% center; //화살표 이미지지정.
  background-color: #fff;
}
select {
  width: 100%;
  height: 100%;
  padding-right: 24px;
  border: 0; //기본 스타일 제거
  -webkit-appearance: none; /* for chrome */
  -moz-appearance: none; /*for firefox*/
  appearance: none;
  box-sizing: border-box; //select 박스의 크기 방식 지정.
  background: transparent; //배경색 투명 처리
}

select::-ms-expand {
  display: none; /*for IE10,11*/
}
.br {
  display: block !important;
}
.essential {
  color: #ff3e30;
}
.etc_span {
  padding: 0 5px;
}
//-------------------------------------------
//개인정보처리방침(팝업창)
/* 팝업창 셋팅 */
.termsWrap {
  margin: 20px 0 0px 0px;
  background: #f7f7f7;
}
.terms_title {
  position: relative;
  padding: 5px 10px;
}
.terms_summary {
  height: 50px;
  overflow-y: scroll;
  font-size: 11px;
  padding: 10px;
}

//-------------------------------------------
//header
header {
  padding: 15px 0;
  border-bottom: 1px solid #ebecef;
  .btn {
    text-align: right;
    width: 1000px;
    margin: 0 auto;
    a {
      display: inline-block;
      background-color: #1e7ee1;
      padding: 10px 20px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      border-radius: 20px;
    }
  }
}
//main
main {
  width: 1000px;
  margin: 60px auto 0;
  h1 {
    font-size: 45px;
    font-weight: bold;
    margin-bottom: 18px;
    text-align: center;
  }
  p {
    font-size: 18px;
    text-align: center;
  }
}
//content
.content_box {
  width: 1000px;
  margin: 60px auto 0;
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #1e7ee1;
    // border-bottom: 1px solid #333333; // 공통 css 때문에 화면 깨짐
    // padding: 0 5px 13px; // 공통 css 때문에 화면 깨짐
  }

  //section_box00
  .section_box00 {
    margin-top: 30px;
    padding: 0 10px;
    .sub_title {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-weight: bold;
      padding-left: 5px;
      img {
        margin-right: 7px;
      }
    }
    .info_box {
      background-color: #f9fafc;
      border-radius: 16px;
      padding: 20px;
      display: flex;
      justify-content: space-between;
    }

    .l_box {
      width: 48%;
    }
    .r_box {
      width: 48%;
    }
    .sub_title_label {
      margin-top: 18px;
    }
    label {
      font-weight: 500;
      font-size: 15px;
      display: block;
      margin-bottom: 5px;
    }
    input {
      width: 100%;
      background-color: #fff;
      border-radius: 6px;
      border: 1px solid #c2c2c2;
      height: 38px;
      padding: 0 10px;
      // margin-bottom: 20px;
    }
    .check_label {
      display: inline-block;
      margin-right: 16px;
      font-size: 14px;
      font-weight: 400;
      color: #000;
      padding: 0;
      input {
        width: auto;
        margin: 0;
        margin-right: 2px;
        height: 30px;
      }
    }
    .adress_box {
      width: 100%;
      background-color: #fff;
      border-radius: 6px;
      border: 1px solid #c2c2c2;
      height: 38px;
      padding: 0 5px 0 10px;
      display: flex;
      align-items: center;
      input {
        border: none;
        background-color: transparent;
        padding: 0;
        height: auto;
        margin: 0;
      }
      button {
        padding: 0 10px;
        color: #fff;
        background-color: #1e7ee1;
        border-radius: 6px;
        width: 62px;
        height: 80%;
        font-size: 13px;
      }
    }
    .country_box {
      width: 100%;
      background-color: #fff;
      border-radius: 6px;
      border: 1px solid #c2c2c2;
      height: 38px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      input {
        border: none;
        background-color: transparent;
        padding: 0;
        height: auto;
        margin: 0;
      }
      button {
        padding: 0 10px;
        color: #fff;
        background-color: #1e7ee1;
        border-radius: 6px;
        width: 62px;
        height: 80%;
        font-size: 13px;
      }
    }
  }
  .footer {
    margin: 25px 0 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    label {
      font-size: 14px;
      color: #000;
      padding: 0;
      span {
        border-bottom: 1px solid #000;
        margin-left: 5px;
      }
    }
    .btn_next {
      a {
        display: block;
        font-size: 15px;
        font-weight: 500;
        padding: 10px 40px;
        border-radius: 6px;
        border: 1px solid #1e7ee1;
        color: #1e7ee1;
      }
    }
  }
}
/* 1000px 이하 */
@media only screen and (max-width: 1000px) {
  .br {
    display: none !important;
  }
  header {
    .btn {
      width: 90%;
    }
  }
  main {
    width: 90%;
    p {
      width: 98%;
      margin: 0 auto;
    }
  }
  .content_box {
    width: 98%;
  }
}
/* 768px 이하 */
@media only screen and (max-width: 768px) {
  .content_box {
    .section_box00 {
      .l_box {
        width: 100%;
      }
      .r_box {
        width: 100%;
      }
      .info_box {
        flex-direction: column;
      }
      .sub_title_label_02 {
        margin-top: 18px;
      }
    }
  }

  .use_pop_box {
    width: 80%;
  }
}
/* 414px 이하 */
@media only screen and (max-width: 414px) {
  main {
    margin: 43px auto 0;
    h1 {
      font-size: 30px;
    }
    p {
      font-size: 15px;
    }
  }
  .content_box {
    width: 96%;
    margin: 50px auto 0;
    .footer {
      flex-direction: column;
      .btn_next {
        margin-top: 30px;
      }
    }
  }

  .use_pop_box {
    width: 90%;
  }
}
</style>
